import { render, staticRenderFns } from "./SampleRunCard.vue?vue&type=template&id=323a16ac"
import script from "./SampleRunCard.vue?vue&type=script&lang=js"
export * from "./SampleRunCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports